export type HeroBackgroundVideo =
  | { type: 'embed'; src: string }
  | { type: 'direct'; src: string };

/**
 * Normalizes a hero background video URL into an embed iframe src (Vimeo /
 * YouTube) or a direct file URL for a muted <video> element.
 */
export function parseBackgroundVideo(raw: string | null | undefined): HeroBackgroundVideo | null {
  const url = raw?.trim();
  if (!url) return null;

  if (url.includes('vimeo.com')) {
    const videoIdMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    const videoId = videoIdMatch?.[1];
    if (!videoId) return { type: 'embed', src: url };
    return {
      type: 'embed',
      src: `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&title=0&byline=0&portrait=0&background=1&muted=1&autopause=0`,
    };
  }

  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const embedMatch = url.match(/embed\/([^?&/]+)/);
    const watchMatch = url.match(/[?&]v=([^&]+)/);
    const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
    const videoId = embedMatch?.[1] || watchMatch?.[1] || shortMatch?.[1] || null;
    if (!videoId) return { type: 'embed', src: url };
    return {
      type: 'embed',
      src: `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1`,
    };
  }

  return { type: 'direct', src: url };
}
